import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import Width from "../../../../ConfigParameters/ConfigParameters/Width";
import Placeholder from "../../../../ConfigParameters/ConfigParameters/Placeholder";
import Label from "../../../../ConfigParameters/ConfigParameters/Label";
import HelperText from "../../../../ConfigParameters/ConfigParameters/HelperText";
import Required from "../../../../ConfigParameters/ConfigParameters/Required";
import HelperImage from "../../../../ConfigParameters/ConfigParameters/HelperImage";
import Rows from "../../../../ConfigParameters/ConfigParameters/Rows";
import TextColor from "../../../../ConfigParameters/ConfigParameters/TextColor";
import FontSize from "../../../../ConfigParameters/ConfigParameters/FontSize";
import FontWeight from "../../../../ConfigParameters/ConfigParameters/FontWeight";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'formTextarea';

const creatorFormInputTextarea = {
    bindings: {
        elementModel: '=',
        parentModel: '<'
    },
    controller: function (ToolbarService, $uibModal, $filter, gettextCatalog) {
        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            defaultConfig.label = gettextCatalog.getString(defaultConfig.label);
            defaultConfig.placeholder = gettextCatalog.getString(defaultConfig.placeholder);
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };

        this.openModal = (imageUrl) => {
            $uibModal.open({
                animation: true,
                template: '<img src="' + $filter('imageUrl')(imageUrl[0].media, 600, 0) + '">'
            });
        }
    },
    template: require('./textareaInput.html')
};

export default angular.module('cms.creator.form.input.textarea', [sectionsLibraryService, toolbarService])
    .run(function (ToolbarService, gettext, SectionsLibraryService) {

        SectionsLibraryService.registerSection({
            icon: 'text_fields',
            type: MODULE_NAME,
            label: gettext('Textarea'),
            group: 'form',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        let textColor = new TextColor();
        textColor.setDefaultValue('');
        let label = new Label();
        label.setDefaultValue(gettext('Textarea'));
        let placeholder = new Placeholder();
        placeholder.setDefaultValue('Textarea');
        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(label),
            ...(placeholder),
            ...(new Required()),
            ...(new Rows()),
            ...(new Width()),
            ...(new HelperText()),
            ...(new HelperImage()),
            ...(textColor),
            ...(new FontSize()),
            ...(new FontWeight()),
            ...(new CustomClassName())
        })
    })
    .component('cmsCreatorFormInputTextarea', creatorFormInputTextarea).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Form/TextareaInput/textareaInput.js